import React, {Component} from "react";
import {Popover, PopoverBody} from "reactstrap";
import "../../_Content/css/eco-template.css";

class FiltroItensEmDivergencia extends Component {

	constructor(props) {
		super(props);

		this.state = {
			erros: true,
			alertas: true,
			avisos: true,
			popoverOpen: false
		};
	}

	toggle = () => {
		if (!this.props.exibirFiltro) {
			return;
		}
		this.setState({popoverOpen: !this.state.popoverOpen});
	};

	onChangeCheckBox(checkbox) {
		this.state.erros = checkbox == 0 ? !this.state.erros : this.state.erros;
		this.state.alertas =
			checkbox == 1 ? !this.state.alertas : this.state.alertas;
		this.state.avisos = checkbox == 2 ? !this.state.avisos : this.state.avisos;
		this.props.action(this.state.erros, this.state.alertas, this.state.avisos);
		this.forceUpdate();
	}

	opcoesRelatorio = () => {
		return (
			<div className="qtdErrosBox">
				<div className="filtroLine">
					<input
						type="checkbox"
						checked={this.state.erros}
						onChange={() => this.onChangeCheckBox(0)}
						className="ecoforms error"
					/>
					<i className="ecoico ecoico-erro"/>
					<p>ERROS</p>
					<span className="ecobtn fit divergenciaBtn">
                        {this.props.quatidadeErros}
                    </span>
				</div>
				<div className="filtroLine">
					<input
						type="checkbox"
						checked={this.state.alertas}
						onChange={() => this.onChangeCheckBox(1)}
						className="ecoforms error"
					/>
					<i className="ecoico ecoico-nao-realizada"/>
					<p>ALERTAS</p>
					<span className="ecobtn fit divergenciaBtn">
                        {this.props.quatidadeAlertas}
                    </span>
				</div>
				<div className="filtroLine">
					<input
						type="checkbox"
						checked={this.state.avisos}
						onChange={() => this.onChangeCheckBox(2)}
						className="ecoforms error"
					/>
					<i className="ecoico ecoico-aviso"/>
					<p>AVISOS</p>
					<span className="ecobtn fit divergenciaBtn">
                        {this.props.quatidadeAvisos}
                    </span>
				</div>
			</div>
		);
	};

	render() {
		return (
			<div className="flexCustom">
				<div>
					<b>Divergências</b>
				</div>
				<a id={"filtroDivergencias-" + this.props.idArquivo}  onClick={this.toggle}>
					<span className="toggleTotalDivergencias">{this.props.totalReg}</span>
				</a>
				<Popover
					placement="bottom"
					isOpen={this.state.popoverOpen}
					target={"filtroDivergencias-" + this.props.idArquivo}
					toggle={this.toggle}
					className="divergenciasBox"
				>
					<PopoverBody>{this.opcoesRelatorio()}</PopoverBody>
				</Popover>
			</div>
		);
	}
}

export default FiltroItensEmDivergencia;



// WEBPACK FOOTER //
// ./src/Componente/Resultado/FiltroItensEmDivergencia.jsx